import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import StyledTooltip from 'components/Elements/StyledTooltip'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { BiMoveVertical } from 'react-icons/bi'
import { FaCamera, FaCheckCircle, FaEye, FaPen } from 'react-icons/fa'
import { AnswerItemContainer } from '../../style'

function AnswerItem({
  answer,
  isSubmitted,
  isPublished = false,
  role,
  isOwn = false,
  onEditAnswer,
  onViewImages,
  onViewAnswer,
}) {
  const { t } = useTranslation()
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: answer?.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const isPurchaserOrEditor = role === 'Purchaser' || role === 'Editor'

  if (isPurchaserOrEditor || isOwn === true || isSubmitted) {
    return (
      <AnswerItemContainer ref={setNodeRef} style={style} {...attributes}>
        <div className="answer-icon">
          {!!answer.is_submitted && (
            <StyledTooltip title={t('tt_story_submitted')} placement="top">
              <div className="submitted-checkmark">
                <FaCheckCircle />
              </div>
            </StyledTooltip>
          )}
        </div>
        <div className="answer-icon" onClick={(e) => onViewImages(e, answer)}>
          <StyledTooltip title={t('tt_view_pictures')} placement="top">
            <FaCamera />
          </StyledTooltip>
        </div>
        <div
          className="answer-icon"
          onClick={(e) => {
            onViewAnswer(e, answer)
          }}
        >
          <StyledTooltip title={t('tt_view_story')} placement="top">
            <FaEye />
          </StyledTooltip>
        </div>
        {!isPublished &&
        (isOwn || role === 'Purchaser' || role === 'Editor') ? (
          <div
            className="answer-icon edit-icon"
            onClick={(e) => {
              onEditAnswer(e, answer)
            }}
          >
            <StyledTooltip title={t('tt_edit_story')} placement="top">
              <FaPen />
            </StyledTooltip>
          </div>
        ) : (
          <div className="answer-icon"></div>
        )}
        <h6 className="ml-2">
          {answer.first_name} {answer.last_name}
        </h6>
        <h6 className="ml-4">
          {moment(answer.last_modified_datetime).format('DD/MM/yy')}
        </h6>

        <div className="move-answer-wrapper ml-auto" {...listeners}>
          {isPurchaserOrEditor ? <BiMoveVertical /> : <></>}
        </div>
      </AnswerItemContainer>
    )
  } else {
    return <div />
  }
}

export default AnswerItem
